import React, { memo } from 'react';

import WaitroseLogo from 'components/WaitroseLogo';

import styles from './FooterBadges.scss';

type FooterBadgesProps = {
  data: {
    copyright: string;
  };
};

const FooterBadges = memo(({ data: { copyright } }: FooterBadgesProps) => (
  <div className={styles.badges}>
    <div className={styles.logoWrapper}>
      <span className={`${styles.logo} no-print`}>
        <WaitroseLogo small />
      </span>
      <small className={styles.copyright}>{copyright}</small>
    </div>
  </div>
));

FooterBadges.displayName = 'FooterBadges';

export default FooterBadges;
